import ko from '@tko/build.knockout';
import $ from 'jquery';
import _ from 'lodash';
import Signals from 'signals';
import templateMarkup from 'raw-loader!./update-modal.html';

    

    function UpdateModal(params) {
        this.bodyWidgetName = params.bodyWidgetName;
        this.id = 'UpdateModal' + params.bodyWidgetName;
        this.title = params.title;
        this.appId = params.appId;
        this.signals = ko.observable({
            onShow: new Signals.Signal(),
            onSave: new Signals.Signal(),
            closeModal: new Signals.Signal()
        });
        this.signals().closeModal.add(_.bind(this.close, this));

        this.enableSave = ko.observable(true /*default to true*/);
    }

    UpdateModal.prototype = {
        show: function(model) {
            this.signals().onShow.dispatch(model);
            $('#' + this.id).modal('show');
        },
        close: function() {
            $('#' + this.id).modal('hide');
        },
        save: function() {
            this.signals().onSave.dispatch();
        },
        dispose: function() {
            this.signals().closeModal.dispose();
        }
    };

    export default { viewModel: UpdateModal, template: templateMarkup };
